/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import _, { split } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import {
  TextField,
  MenuItem,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  autoFormateDate,
  fromQtrToDT,
  qtrToPreviousEndDt,
  qtrToPreviousStartDt,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  dispatchQtrRange,
  dispatchErrorMsgAdjust,
  dispatchPerformResolutionObj,
  getPlanTypeValues,
  getRebateProgrameList,
  dispatchRebateProgramName,
  getCmsRebateGroup,
  dispatchCmsRebateGroupName,
  getSelectedOption,
  getCmsRebateGroupListData,
  dispatchCmsRebateGroupNameList,
  getCmsAdjustment,
  dispatchDisplayObjAdjustment,
  dispatchCmsRebateGroupList,
  setFinalGroupByQtr,
  getCMSRptAdjSingleRpcQtr,
  getCMSRptAdjGrpRpcQtr,
  getCMSRptAdjLoadQtr,
  getCMSMaxQtr,
} from '../Store/action';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  REBATE_PROGRAM_REQUIRED,
  STATUS_MSG,
  SUCCESS_MSG,
  QUARTER_REQUIRED,
  QUARTER_DATE_REQUIRED_CMS,
  REBATE_REPORTING_REQUIRED,
} from '../../../../SharedModules/Errors/constantMessageData';
import { validateDateQuarter } from '../../../../SharedModules/utilities/dateUtilities';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import GroupOfRebateProgramComponent from '../../../../SharedModules/CustomGroupOfRebateProgram/GroupOfRebateProgramComponent';
import {
  checkQuarterValidation,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import showPreloader from '../../../../interceptor/store/Actions';

const CmsReport = (props) => {
  // use Selector function
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const getadjustmentData = useSelector(
    (state) => state?.sharedState?.CmsAdjustReducer?.adjustmentData
  );
  const requestCurrentDisData = useSelector(
    (state) => state?.sharedState?.CmsAdjustReducer?.performResolutionObj
  );
  const planTypeList = useSelector(
    (state) => state?.sharedState?.CmsAdjustReducer?.planType
  );
  const getRebateGroupList = useSelector(
    (state) => state?.sharedState?.CmsAdjustReducer?.listRebateGroup
  );

  const getErrorMsg = useSelector(
    (state) => state?.sharedState?.CmsAdjustReducer?.errorMsgAdjust
  );

  const {
    startQtr: startQtrValue,
    rebateCategoryValue,
    rebateGroupCategoryValue,
    selectedOptionValue,
    displayObj: { startQtr: displayQtr },
  } = useSelector((state) => state?.sharedState?.CmsAdjustReducer);

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  const getCmsRebateGroupList = useSelector(
    (state) => state?.sharedState?.CmsAdjustReducer?.rebateGroup
  );

  const [radioList, setRadioList] = React.useState([]);
  const [isSearchClicked, setSearchClicked] = useState(false);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [rebateGroupList, setRebateGroupList] = React.useState([]);
  const [rebateList, setRebateList] = React.useState([]);
  const dispatch = useDispatch();
  const [startQtr, setStartQtr] = React.useState(startQtrValue);
  const [selectedOption, setSelectedOption] =
    React.useState(selectedOptionValue);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [popupQtr, setPopupQtr] = React.useState('');
  // local variable

  const [state, setState] = React.useState(
    requestCurrentDisData?.state || {
      planTypeCd: userDefaults?.planTypeCd ? userDefaults?.planTypeCd : 'FD',
      rebateProgramCd: userDefaults?.rebateProgramCd || '-1',
      quarter: '',
      rebateCategory: rebateCategoryValue,
      rebateGroupCategory: rebateGroupCategoryValue,
    }
  );

  // dispatch function
  const setPerformScrData = (value) =>
    dispatch(dispatchPerformResolutionObj(value));
  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    setPerformScrData({
      fullScreenView: !fullScreenView,
      state: state,
    });
  };
  // Plan type useEffect
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
    if (startQtrValue && checkQuarterValidation(startQtrValue)) {
      fetchGroupOfRebateProgramList(startQtrValue);
    }
  }, []);
  const rebatepgmDropdown = async (planType) => {
    const rebateProgramDataList = await dispatch(
      getRebateProgrameList(planType)
    );
    let list = [];
    if (
      rebateProgramDataList?.status === STATUS_MSG &&
      rebateProgramDataList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(rebateProgramDataList.data)) {
        list = _.map(rebateProgramDataList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };
  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);
  // get rebate program
  React.useEffect(() => {
    rebatepgmDropdown(state.planTypeCd);
  }, [state.planTypeCd]);

  const getQuarterValue = async (load) => {
    let qtr = '';
    if (selectedOption == 'Single') {
      qtr = await dispatch(
        getCMSRptAdjSingleRpcQtr({ rebateProgramCd: state.rebateProgramCd })
      );
    } else {
      qtr = await dispatch(getCMSRptAdjGrpRpcQtr());
    }
    let finalqtr = startQtr;
    let ls_qtr = '';
    if (load) {
      const loadqtr = await dispatch(
        getCMSRptAdjLoadQtr({ rebateProgramCd: state.rebateProgramCd })
      );
      if (qtr && !loadqtr) ls_qtr = qtr;
      else if (!qtr && loadqtr) ls_qtr = loadqtr;
      else if (qtr && loadqtr) {
        if (new Date(fromQtrToDT(qtr)) > new Date(fromQtrToDT(loadqtr)))
          ls_qtr = qtr;
        else ls_qtr = loadqtr;
      }
      if (ls_qtr) {
        const splitedValue = ls_qtr.split('Q');
        const fqtr =
          parseInt(splitedValue[0]) >= 4 ? 1 : parseInt(splitedValue[0]) + 1;
        const fyear =
          parseInt(splitedValue[0]) >= 4
            ? parseInt(splitedValue[1]) + 1
            : splitedValue[1];
        finalqtr = fqtr + 'Q' + fyear;
      } else {
        const maxQtr = await dispatch(
          getCMSMaxQtr({ rebateProgramCd: state.rebateProgramCd })
        );
        finalqtr = maxQtr;
      }
      // } else {
      //   if (qtr && !finalqtr) finalqtr = qtr;
      //   else if (qtr && finalqtr) {
      //     if (new Date(fromQtrToDT(qtr)) > new Date(fromQtrToDT(finalqtr)))
      //       finalqtr = qtr;
      //   }
    }
    dispatch(dispatchQtrRange({ startQtr: finalqtr }));
    setStartQtr(finalqtr);
  };

  React.useEffect(() => {
    if (!displayQtr && state?.rebateProgramCd) {
      getQuarterValue(true);
    }
  }, [state.rebateProgramCd]);

  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    let localErr = getErrorMsg || [];
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      setPerformScrData({
        state: { ...state, planTypeCd: value, rebateProgramCd: '-1' },
      });
    }
    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
      setPerformScrData({
        state: { ...state, [name]: value },
      });
    }
    localErr = localErr.filter((item) => item.field != 'rebateProgramCd');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgAdjust(unique));
  };
  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg || [];
    const data = value;
    if (type === 'rebateProgramCd') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      if (!value || value === '-1') {
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: REBATE_PROGRAM_REQUIRED,
        });
      }
    }

    if (type === 'rebateGroupCategory') {
      if (!value || value === '-1') {
        localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      }
    }
    if (type === 'rebateCategory') {
      if (!value || value === 'Please Select One') {
        localErr = localErr.filter((item) => item.field !== 'reportingGroup');
        localErr.push({
          field: 'reportingGroup',
          errorType: 'reportingGroup',
          message: REBATE_REPORTING_REQUIRED,
        });
      } else {
        localErr = localErr.filter((item) => item.field !== 'reportingGroup');
      }
    }

    let fromError = [];

    if (type === 'fromDate') {
      const value1 = autoFormateDate(value);

      setStartQtr(value1.toUpperCase());
      fromError = validateDateQuarter(value1, 'fromDate');

      localErr = [...localErr, ...fromError];
    }

    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgAdjust(unique));
  };

  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther('/cmsReportAdjustmentDetail', true);
    } else {
      tabHighLigther('/cmsReportAdjustmentDetail', false);
    }
  }, [JSON.stringify(getErrorMsg)]);

  const previousQtr = (qtr) => {
    let splitted = qtr?.split('Q');
    return `${parseInt(splitted?.[0]) < 2 ? 4 : parseInt(splitted?.[0]) - 1}Q${
      parseInt(splitted?.[0]) < 2 ? splitted?.[1] - 1 : splitted?.[1]
    }`;
  };

  // Search button on click functionality
  const onClickOnSearch = async () => {
    const rebateProgramName = rebateProgramList.find(
      (item) => item.id == state.rebateProgramCd
    );
    let localErr = getErrorMsg || [];
    if (state.rebateProgramCd === '-1' && selectedOption == 'Single') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }

    if (
      (state?.rebateCategory === '' || state?.rebateCategory === '-1') &&
      selectedOption === 'Group'
    ) {
      localErr = localErr.filter((item) => item.field !== 'reportingGroup');
      localErr.push({
        field: 'reportingGroup',
        errorType: 'reportingGroup',
        message: REBATE_REPORTING_REQUIRED,
      });
    }
    const fromError = validateDateQuarter(startQtr, 'fromDate');
    localErr = [...localErr, ...fromError];

    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgAdjust(unique));
    if (localErr.length == 0 && startQtr) {
      const maxQtr = await dispatch(
        getCMSMaxQtr({ rebateProgramCd: state.rebateProgramCd })
      );
      if (new Date(fromQtrToDT(startQtr)) > new Date(fromQtrToDT(maxQtr))) {
        setOpen(true);
        setPopupQtr(maxQtr);
        dispatch(showPreloader(false));
        return;
      }
    }
    if (selectedOption == 'Single' && localErr.length == 0) {
      // if (state.rebateProgramCd != '-1' && quarterTest1.test(startQtr))
      if (state.rebateProgramCd != '-1' && startQtr != '') {
        function convertDateRange(dateRange) {
          const dates = dateRange.split(' - ');
          const startDate = new Date(dates[0]);

          const startQuarter = Math.floor(startDate.getMonth() / 3 + 1);
          const startYear = startDate.getFullYear();

          const formattedString = `${startQuarter}Q${startYear}`;

          return formattedString;
        }
        let pastqtr = previousQtr(startQtr);
        const fromRange = convertInput(startQtr);
        function getQuarterDates(quarter) {
          const year = parseInt(quarter?.slice(-4));
          const quarterNum = parseInt(quarter?.slice(0, 1));
          let startDate;
          let endDate;

          switch (quarterNum) {
            case 1:
              startDate = new Date(year, 0, 1);
              endDate = new Date(year, 2, 31);
              break;
            case 2:
              startDate = new Date(year, 3, 1);
              endDate = new Date(year, 5, 30);
              break;
            case 3:
              startDate = new Date(year, 6, 1);
              endDate = new Date(year, 8, 30);
              break;
            case 4:
              startDate = new Date(year, 9, 1);
              endDate = new Date(year, 11, 31);
              break;
          }

          const options = { month: '2-digit', day: '2-digit', year: 'numeric' };
          const startStr = startDate?.toLocaleDateString('en-US', options);
          const endStr = endDate?.toLocaleDateString('en-US', options);

          return { startDate: startStr, endDate: endStr };
        }
        const qtr = getQuarterDates(fromRange);
        setSearchClicked(true);
        dispatch(
          getCmsAdjustment({
            rebateProgramCd:
              selectedOption == 'Single'
                ? rebateProgramName?.rebateProgramCd
                : state.rebateGroupCategory,
            beginDate: qtr.startDate,
            endDate: qtr.endDate,
            beginQtr: '000000',
            endQtr: pastqtr,
          })
        );

        dispatch(dispatchRebateProgramName(rebateProgramName));
        dispatch(dispatchQtrRange({ startQtr }));

        dispatch(getSelectedOption({ selectedOptionValue: selectedOption }));
        dispatch(
          dispatchCmsRebateGroupName({
            rebateGroupCategoryValue: state?.rebateGroupCategory,
          })
        );
        dispatch(
          dispatchCmsRebateGroupNameList({
            rebateCategoryValue: state?.rebateCategory,
          })
        );
        dispatch(
          dispatchDisplayObjAdjustment({
            rebateProgramName,
            rebateCategoryValue: state?.rebateCategory,
            groupOfRebateProgramList: getRebateGroupList?.data,
            rebateGroupCategoryValue: state?.rebateGroupCategory,
            selectedOptionValue: selectedOption,
            startQtr,
          })
        );
        // const updateTabs =
        //   JSON.parse(localStorage.getItem('tabItemsData')) === null
        //     ? []
        //     : JSON.parse(localStorage.getItem('tabItemsData'));
        // updateTabs.push({
        //   navTo: '/displayCmsReportAdjustmentDetail',
        //   value: 'Display CMS Report Adjustment Detail',
        // });
        // localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
        // if (props.history) {
        // }
      }
    } else {
      // if (
      //   state.rebateCategory != 'Please Select One' &&
      //   quarterTest1.test(startQtr)
      // )

      if (localErr.length == 0) {
        const fromRange = convertInput(startQtr);
        function getQuarterDates(quarter) {
          const year = parseInt(quarter?.slice(-4));
          const quarterNum = parseInt(quarter?.slice(0, 1));
          let startDate;
          let endDate;

          switch (quarterNum) {
            case 1:
              startDate = new Date(year, 0, 1);
              endDate = new Date(year, 2, 31);
              break;
            case 2:
              startDate = new Date(year, 3, 1);
              endDate = new Date(year, 5, 30);
              break;
            case 3:
              startDate = new Date(year, 6, 1);
              endDate = new Date(year, 8, 30);
              break;
            case 4:
              startDate = new Date(year, 9, 1);
              endDate = new Date(year, 11, 31);
              break;
          }

          const options = { month: '2-digit', day: '2-digit', year: 'numeric' };
          const startStr = startDate?.toLocaleDateString('en-US', options);
          const endStr = endDate?.toLocaleDateString('en-US', options);

          return { startDate: startStr, endDate: endStr };
        }
        let pastqtr = previousQtr(startQtr);
        const qtr = getQuarterDates(startQtr);
        const str = getRebateGroupList?.data?.map((item) => {
          return `${item.rebateProgramCode}`;
        });
        setSearchClicked(true);
        dispatch(
          getCmsAdjustment({
            rebateProgramCd:
              selectedOption == 'Single'
                ? rebateProgramName?.rebateProgramCd
                : str?.toString(),
            beginDate: qtr.startDate,
            endDate: qtr.endDate,
            beginQtr: '000000',
            endQtr: pastqtr,
          })
        );
        dispatch(dispatchRebateProgramName(rebateProgramName));
        dispatch(dispatchQtrRange({ startQtr }));
        dispatch(getSelectedOption({ selectedOptionValue: selectedOption }));

        dispatch(
          dispatchCmsRebateGroupName({
            rebateGroupCategoryValue: state?.rebateGroupCategory,
          })
        );
        dispatch(
          dispatchCmsRebateGroupNameList({
            rebateCategoryValue: state?.rebateCategory,
          })
        );
        dispatch(
          dispatchDisplayObjAdjustment({
            rebateProgramName,
            rebateCategoryValue: state?.rebateCategory,
            groupOfRebateProgramList: getRebateGroupList?.data,
            rebateGroupCategoryValue: state?.rebateGroupCategory,
            selectedOptionValue: selectedOption,
            startQtr,
          })
        );
      }
    }
  };
  if (
    isSearchClicked &&
    getadjustmentData?.cmsreportAdjustmentDetailsVO?.length > 0
  ) {
    dispatch(setFinalGroupByQtr([]));
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/displayCmsReportAdjustmentDetail',
      value: 'Display CMS Report Adjustment Detail',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/displayCmsReportAdjustmentDetail',
    });
    dispatch(clearReduxForFilterAndSort('/displayCmsReportAdjustmentDetail'));
  }
  // converting mm/dd/yyyy to mQyyyy
  function convertDateRange(dateRange) {
    const dates = dateRange.split(' - ');
    const startDate = new Date(dates[0]);

    const startQuarter = Math.floor(startDate.getMonth() / 3 + 1);
    const startYear = startDate.getFullYear();

    const formattedString = `${startQuarter}Q${startYear}`;

    return formattedString;
  }
  // converting startQtr to required format
  function convertInput(input) {
    const datePattern = /\d{2}\/\d{2}\/\d{4}/;
    const quarterPattern = /\dQ\d{4}/;

    if (datePattern.test(input)) {
      return convertDateRange(input);
    }
    return input;
  }

  // rebate Group
  React.useEffect(() => {
    let data1 =
      getCmsRebateGroupList?.data?.map((item) => {
        return {
          ...item,
          name: item,
          id: item,
        };
      }) || [];
    // data1 = [
    //   {
    //     name: '',
    //     id: -1,
    //   },
    //   ...data1,
    // ];
    setRebateGroupList(data1);
  }, [getCmsRebateGroupList]);

  React.useEffect(() => {
    let data2 =
      getRebateGroupList?.data?.map((item) => {
        return {
          ...item,
          name: `${item.rebateProgramCode} | ${item.shortDesc}`,
          id: `${item.rebateProgramCode} | ${item.shortDesc}`,
        };
      }) || [];
    data2 = [
      {
        name: '',
        id: -1,
      },
      ...data2,
    ];
    setState({
      ...state,
      rebateGroupCategory: data2[0].name,
    });

    setRebateList(data2);
  }, [getRebateGroupList]);
              
  // remove no data error msg
  React.useEffect(() => {
    dispatch(dispatchErrorMsgAdjust([]));
  }, [ selectedOption, planTypeList, startQtr, state.rebateProgramCd, fullScreenView]);

  const fetchGroupOfRebateProgramList = (val) => {
    if (checkQuarterValidation(val)) {
      dispatch(
        getCmsRebateGroup({
          utilQtr: convertInput(val),
        })
      );
    }
  };
  const fetchAllRebateProgramWithGroup = (val) => {
    if (val) {
      dispatch(
        getCmsRebateGroupListData({
          quarter: convertInput(startQtr),
          rebateProgramCode: val,
        })
      );
    }
  };
  // setting Quarter From
  const handlefromChange = (e) => {
    const value = e.target.value.toUpperCase();

    setStartQtr(value);
    let localErr = getErrorMsg || [];
    localErr = localErr.filter((item) => item.field !== 'fromDate');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgAdjust(unique));
  };

  let errorMessages = getErrorMsg.map((error) => {
    if (error.field == 'fromDate') {
      if (startQtr.length === 0) {
        return { ...error, message: QUARTER_REQUIRED };
      }
      return { ...error, message: QUARTER_DATE_REQUIRED_CMS };
    }
    return error;
  });
  errorMessages = [...new Set(errorMessages?.map((obj) => obj.message))];

  return (
    <>
      <div className='tabs-container'>
        <Spinner load={spinnerLoader} />
        <CustomSeparator
          parent1='State Reports'
          parent2='CMS Report Adjustment Detail'
        />
        <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />
        <div className='tab-body'>
          <CommonModal
            open={open}
            viewAction
            className='dialog-420'
            viewHeader
            onOk={() => setOpen(false)}
            okTitle='Ok'
            onClose={() => setOpen(false)}
            modalTitle='Request CMS Report Adjustment Detail Report'
            childrenComponent={`Quarter entered cannot be greater than quarter ${popupQtr}`}
          />
          {!fullScreenView && (
            <>
              <div className='row'>
                <div className='col-8 frr-two-col-radio'>
                  <fieldset className='custom-fieldset'>
                    <legend className='same-font-family'>Selected By</legend>
                    <div className='form-wrapper p-3'>
                      <div className='mui-custom-form with-select field-xl no-lbl'>
                        <RadioGroup
                          row
                          name='report-quarter'
                          required
                          value={selectedOption}
                          onChange={(e) => {
                            setSelectedOption(e.target.value);
                            setState({
                              ...state,
                              rebateCategory: '-1',
                            });
                            setPerformScrData({
                              state: { ...state, rebateCategory: '-1' },
                            });
                            dispatch(
                              getSelectedOption({
                                selectedOptionValue: e.target.value,
                              })
                            );
                            // getQuarterValue();
                            let localErr = getErrorMsg || [];
                            localErr = localErr.filter(
                              (item) => item.field !== 'rebateProgramCd'
                            );

                            localErr = localErr.filter(
                              (item) => item.field !== 'reportingGroup'
                            );
                            const unique = [...new Set(localErr)];
                            dispatch(dispatchErrorMsgAdjust(unique));
                          }}
                        >
                          <FormControlLabel
                            // style={{ marginRight: '10px' }}
                            value='Single'
                            control={<Radio />}
                            label='Single Rebate Program'
                          />
                          <FormControlLabel
                            // style={{ marginRight: '10px' }}
                            value='Group'
                            control={<Radio />}
                            label='Group of Rebate Programs'
                          />
                        </RadioGroup>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div className='col-4'>
                  <fieldset className='custom-fieldset'>
                    <legend className='same-font-family'>
                      Quarter<span className='mandatory'> *</span>
                    </legend>
                    <div className='form-wrapper p-0'>
                      <div className='mui-custom-form with-select field-xl no-lbl mandate-fields'>
                        <TextField
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputProps={{ maxLength: 10, id: 'from' }}
                          required
                          label='From'
                          name='From'
                          id='from'
                          value={startQtr}
                          onChange={handlefromChange}
                          onBlur={(e) => {
                            const value = autoFormateDate(e?.target?.value);
                            setStartQtr(value);
                            handleOnblurEvent('fromDate', value);
                            dispatch(dispatchQtrRange({ startQtr: value }));
                            if (selectedOption == 'Group')
                              fetchGroupOfRebateProgramList(e?.target?.value);
                            setState({
                              ...state,
                              rebateCategory: '-1',
                            });
                            setPerformScrData({
                              state: { ...state, rebateCategory: '-1' },
                            });
                            dispatch(dispatchCmsRebateGroupList([]));
                            setRebateGroupList([]);
                          }}
                          error={errorMessages.some(
                            (val) =>
                              val === QUARTER_DATE_REQUIRED_CMS ||
                              val === QUARTER_REQUIRED
                          )}
                          helperText={
                            errorMessages.indexOf(QUARTER_DATE_REQUIRED_CMS) !==
                            -1
                              ? QUARTER_DATE_REQUIRED_CMS
                              : errorMessages.indexOf(QUARTER_REQUIRED) !== -1
                              ? QUARTER_REQUIRED
                              : ''
                          }
                        />
                      </div>
                    </div>
                  </fieldset>
                </div>
                {selectedOption == 'Single' && (
                  <div className='col-4 frr-two-col-radio'>
                    <RadioGroupComponent
                      data-testid='CMS_PlanType'
                      id='radio-button-for-rcdd_id'
                      labelName='Plan Type'
                      required
                      optionList={radioList || []}
                      defaultValue={state && state.planTypeCd}
                      filterAction={(e) => {
                        handleOnChangeEvent(e, 'planTypeCd');
                      }}
                      className='log-batch-filter-radio frr-checkInvoiceRadio'
                    />
                  </div>
                )}
                {selectedOption == 'Single' && (
                  <div className='col-4 frr-two-col-radio '>
                    <fieldset className='custom-fieldset'>
                      <legend className='same-font-family'>
                        Rebate Program<span className='mandatory'> *</span>
                      </legend>
                      <div className='form-wrapper p-3'>
                        <div className='mui-custom-form with-select field-xl no-lbl mandate-fields'>
                          <TextField
                            name='rebateProgram'
                            id='rebate_program'
                            data-testid='CMS_Rebate_Program'
                            label='Rebate Program'
                            fullWidth
                            select
                            required
                            inputProps={{ maxLength: 11, id: 'rebate_program' }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            // className={
                            //   getErrorMsg?.length > 0
                            //     ? _.map(getErrorMsg, (l) =>
                            //         l.field === 'rebateProgramCd'
                            //           ? 'mandate-fields'
                            //           : null
                            //       )
                            //     : null
                            // }
                            onBlur={(e) =>
                              handleOnblurEvent(
                                'rebateProgramCd',
                                e.target.value
                              )
                            }
                            onChange={(e) =>
                              handleOnChangeEvent(
                                e.target.value,
                                'rebateProgramCd'
                              )
                            }
                            value={
                              state && state.rebateProgramCd
                                ? state.rebateProgramCd
                                : ''
                            }
                            error={
                              errorMessages.indexOf(REBATE_PROGRAM_REQUIRED) !==
                              -1
                            }
                            helperText={
                              getErrorMsg?.length > 0
                                ? _.map(getErrorMsg, (l) =>
                                    l.field === 'rebateProgramCd'
                                      ? l.message
                                      : null
                                  )
                                : null
                            }
                          >
                            <MenuItem
                              selected
                              key='Please Select One'
                              value='-1'
                            />
                            {rebateProgramList?.length > 0
                              ? rebateProgramList?.map((item) => {
                                  return (
                                    <MenuItem key={item.id} value={item.id}>
                                      {item.name}
                                    </MenuItem>
                                  );
                                })
                              : null}
                          </TextField>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                )}
                {selectedOption == 'Group' && (
                  <div className='col-8 frr-two-col-radio '>
                    <fieldset className='custom-fieldset'>
                      <legend className='same-font-family'>
                        CMS Reporting Group<span className='mandatory'> *</span>
                      </legend>
                      <div className='form-wrapper p-3'>
                        <div className='mui-custom-form with-select field-xl no-lbl'>
                          <TextField
                            name='reporting_group'
                            id='reporting_group'
                            label='CMS Reporting Group'
                            data-testid='cms64-reporting-group'
                            fullWidth
                            select
                            required
                            inputProps={{
                              maxLength: 11,
                              id: 'reporting_group',
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onChange={(e) => {
                              fetchAllRebateProgramWithGroup(e.target?.value);
                              setState({
                                ...state,
                                rebateCategory: e.target.value,
                              });
                              setPerformScrData({
                                state: {
                                  ...state,
                                  rebateCategory: e.target.value,
                                },
                              });
                            }}
                            onBlur={(e) => {
                              let localErr = getErrorMsg || [];
                              if (!e.target.value || e.target.value === '-1') {
                                localErr = localErr?.filter(
                                  (item) => item.field !== 'reportingGroup'
                                );
                                localErr.push({
                                  field: 'reportingGroup',
                                  errorType: 'reportingGroup',
                                  message: REBATE_REPORTING_REQUIRED,
                                });
                              } else {
                                localErr = localErr.filter(
                                  (item) => item.field !== 'reportingGroup'
                                );
                              }
                              const unique = [...new Set(localErr)];
                              dispatch(dispatchErrorMsgAdjust(unique));
                            }}
                            value={state?.rebateCategory}
                            className={
                              getErrorMsg?.length > 0
                                ? _.map(getErrorMsg, (l) =>
                                    l.field == 'reportingGroup'
                                      ? 'mandate-fields'
                                      : null
                                  )
                                : null
                            }
                            error={
                              getErrorMsg?.length > 0
                                ? _.map(getErrorMsg, (l) =>
                                    l.field === 'reportingGroup'
                                      ? l.message
                                      : null
                                  )
                                : null
                            }
                            helperText={
                              getErrorMsg?.length > 0
                                ? _.map(getErrorMsg, (l) =>
                                    l.field === 'reportingGroup'
                                      ? l.message
                                      : null
                                  )
                                : null
                            }
                          >
                            <MenuItem
                              key=''
                              value='-1'
                              className='frr-dropdown-blank-item'
                            />
                            {rebateGroupList?.length > 0
                              ? rebateGroupList?.map((item) => {
                                  return (
                                    <MenuItem key={item.id} value={item.id}>
                                      {item.name}
                                    </MenuItem>
                                  );
                                })
                              : null}
                          </TextField>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                )}
                {selectedOption === 'Group' && (
                  <div className='col-4 btn-wrapper mt-5'>
                    <div className='float-right hide-on-print'>
                      <Button
                        className='btn btn-success btn-search'
                        data-testid='view_detail_ia'
                        type='button'
                        onClick={onClickOnSearch}
                      >
                        {' '}
                        <SVGComponent iconName='Icon-search' /> {'  '} Search
                      </Button>
                    </div>
                  </div>
                )}
              </div>
              {selectedOption !== 'Group' && (
                <div className='col-12 btn-wrapper mb-2'>
                  <div className='float-right mt-2 hide-on-print'>
                    <Button
                      className='btn btn-success btn-search'
                      data-testid='view_detail_ia'
                      type='button'
                      onClick={onClickOnSearch}
                    >
                      {' '}
                      <SVGComponent iconName='Icon-search' /> {'  '} Search
                    </Button>
                  </div>
                </div>
              )}
            </>
          )}
          {selectedOption === 'Group' && (
            <div className='panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk'>
              <GroupOfRebateProgramComponent
                fullScreenView={fullScreenView}
                handleFullScreenView={handleFullScreenView}
                data={
                  state?.rebateCategory !== '' && state?.rebateCategory !== '-1'
                    ? getRebateGroupList?.data?.map((item) => {
                        item.rebateProgramCd = item.rebateProgramCode;
                        item.shortDescr = item.shortDesc;
                        return item;
                      })
                    : []
                }
                fileName='G-Rebate Program Grid'
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CmsReport;
